// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2ftqD","title":"FrontImage_title__1z5RV"};